import _ from 'lodash';

const layers = ['base', 'cart', 'date-picker', 'drawer', 'modal'];

export default name => _.indexOf(layers, name);



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/getLayer.js